import React from 'react';

import useStyles from './styles';

import Layout from '../Layout';

interface Props {
    heading: React.ReactNode;
    content: React.ReactNode;
    advantages?: React.ReactNode;
    className?: string;
}

const TopicTemplate: React.FC<Props> = ({ heading, content, advantages, className }) => {
    const { classes, cx } = useStyles();
    return (
        <Layout>
            <div className={cx(classes.root, className)}>
                {heading}
                {content}
                {advantages}
            </div>
        </Layout>
    );
};

export default TopicTemplate;
